// SearchPage Constants
export const SEARCH_TYPE_LABELS = {
  web: 'Web',
  game: 'Games',
  education: 'Education',
  facts: 'Facts',
  images: 'Images',
  news: 'News',
  videos: 'Videos',
};

// Google CSE IDs for different search types (same as Laravel)
export const GOOGLE_CSE_IDS = {
  web: '010583556442751503576:0eytod7x98c',
  game: 'db67f85e1ad2afd97',
  education: 'edc2c57c1a7ef008f',
  facts: '82dc7c04ace28ce47',
  news: '3825933210492078f',
  videos: '77c42d85e7638c60e',
  images: 'ddd7e3e1e93e16757', // Images CSE ID from Laravel
};

// Enhanced prefixes for each category
export const prefixes = {
  learn: 'I want to learn about ',
  stories: 'Tell me a story about ',
  games: 'Let\'s play a game about ',
  riddles: 'Give me a riddle about ',
  art: 'Show me how to draw ',
  science: 'Explain the science behind ',
  fun: 'Show me something fun about ',
  facts: 'Tell me some facts about ',
  math: 'Help me solve math problems on ',
  nature: 'Tell me about '
};

// Enhanced topics per category
export const topics = {
  learn: ['the solar system', 'volcanoes', 'robotics', 'dinosaurs', 'oceans', 'space exploration'],
  stories: ['brave knights', 'magical forests', 'space adventures', 'underwater kingdoms', 'friendly dragons'],
  games: ['word puzzles', 'memory games', 'math challenges', 'science experiments', 'art projects'],
  riddles: ['animals', 'nature', 'everyday objects', 'colors', 'shapes', 'numbers'],
  art: ['animals', 'landscapes', 'space scenes', 'underwater worlds', 'fantasy creatures'],
  science: ['how rainbows form', 'why the sky is blue', 'how plants grow', 'animal adaptations'],
  fun: ['jokes', 'magic tricks', 'dance moves', 'singing songs', 'creative crafts'],
  facts: ['amazing animals', 'incredible inventions', 'famous landmarks', 'space discoveries'],
  math: ['addition', 'subtraction', 'multiplication', 'shapes', 'patterns', 'measurement'],
  nature: ['trees', 'flowers', 'animals', 'weather', 'seasons', 'ecosystems']
};

// Available mini-apps for the launcher
export const availableApps = [
  {
    id: 'coloring',
    name: 'Coloring App',
    description: 'Interactive coloring canvas',
    config: {
      type: 'miniapp',
      app: 'coloring',
      props: {
        palette: ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff', '#00ffff', '#ffa500', '#800080']
      }
    }
  },
  {
    id: 'tictactoe',
    name: 'Tic Tac Toe',
    description: 'Classic game',
    config: {
      type: 'miniapp',
      app: 'tictactoe',
      props: {}
    }
  },
  {
    id: 'mathquiz',
    name: 'Math Quiz',
    description: 'Math quizzes with customizable question count',
    config: {
      type: 'miniapp',
      app: 'mathquiz',
      props: {}
    }
  },
  {
    id: 'engine_mc_habitats',
    name: 'Habitat quiz (engine)',
    description: 'JSON multiple-choice — animal homes',
    config: {
      type: 'miniapp',
      app: 'engine_multiple_choice',
      props: {
        title: 'Animal homes',
        hints: [
          'Think about what animals need to stay alive every day.',
          'Oceans and forests can both be habitats for different creatures.',
        ],
        content: {
          instructions: 'Pick the answer that fits best.',
          questions: [
            {
              id: 'q1',
              prompt: 'What does a habitat give animals?',
              choices: [
                { id: 'a', text: 'Only toys', correct: false },
                { id: 'b', text: 'Food, water, and shelter', correct: true },
                { id: 'c', text: 'Nothing', correct: false },
              ],
              explanation: 'A good habitat helps animals find food, water, space, and shelter.',
            },
          ],
        },
      },
    },
  },
  {
    id: 'engine_robot_sequence',
    name: 'Robot steps (engine)',
    description: 'JSON sequencing — correct startup order',
    config: {
      type: 'miniapp',
      app: 'engine_sequence',
      props: {
        title: 'Robot startup steps',
        hints: ['What should happen before the robot moves?'],
        content: {
          instructions: 'Use arrows to order the steps.',
          items: [
            { id: 's1', text: 'Clear the floor of people and pets.' },
            { id: 's2', text: 'Turn on power after an adult checks.' },
            { id: 's3', text: 'Let sensors warm up and calibrate.' },
            { id: 's4', text: 'Try one small slow movement first.' },
          ],
          correctOrder: ['s1', 's2', 's3', 's4'],
        },
      },
    },
  },
  {
    id: 'engine_math_pattern',
    name: 'Number pattern (engine)',
    description: 'JSON pattern — what comes next?',
    config: {
      type: 'miniapp',
      app: 'engine_pattern',
      props: {
        title: 'What comes next?',
        hints: ['Say the numbers out loud — same jump each time?'],
        content: {
          instructions: 'Which number continues the pattern?',
          sequence: [2, 4, 6, 8],
          choices: [
            { id: 'a', text: '9', correct: false },
            { id: 'b', text: '10', correct: true },
            { id: 'c', text: '7', correct: false },
          ],
          explanation: 'We add 2 each time, so after 8 comes 10.',
        },
      },
    },
  },
];

// Supported file types for upload
export const supportedFileTypes = {
  // Images
  'image/jpeg': true,
  'image/png': true,
  'image/gif': true,
  'image/webp': true,
  // Documents
  'application/pdf': true,
  'text/plain': true,
  'text/csv': true,
  'application/vnd.ms-excel': true,
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': true,
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': true,
  'application/msword': true,
  'application/json': true,
  'text/markdown': true,
  'text/html': true,
  // Code
  'text/javascript': true,
  'text/x-python': true,
  'application/x-python-code': true,
  'text/x-c': true,
  'text/x-c++': true,
  'text/x-java': true
}; 